import React from "react";
import styled from "styled-components";

export const DiscountList = ({discountList}) => {
    return (
        <StyledDiscountList>
            {discountList?.map((discount, i) => {
                const policy = discount.policy?.toLowerCase()
                return (
                    <DiscountItem key={i}>
                        <PercentageItem>{discount.percentage}%</PercentageItem> off when
                        booking {policy === "first class" ? "your " : " "}
                        {discount.policy?.toLowerCase()}
                    </DiscountItem>
                )
            })}
        </StyledDiscountList>
    )
};

const StyledDiscountList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const DiscountItem = styled.li`
    font-weight: 600;
    font-size: 14px;
    color: #191d3a60;
`;

const PercentageItem = styled.span`
    color: #191d3a;
`;
